<script setup lang="ts">
    // useRedirect();
</script>

<template>
    <nuxt-loading-indicator />
    <nuxt-pwa-manifest />
    <vz-appbar />
    <NuxtErrorBoundary>
        <!-- ... -->
        <template #error="{ error, clearError }">
            <p>An error occurred: {{ error }}</p>

            <button @click="clearError">Clear error</button>
        </template>
    </NuxtErrorBoundary>
    <nuxt-layout>
        <nuxt-page />
    </nuxt-layout>
    <vz-toast position="bottom-right" />
    <div id="dialog-outlet" class="modal-outlet"></div>
    <modal-confirm-modal />
</template>

<style lang="scss">
    #mijn-epd {
        display: grid;
        grid-template: 100px auto minmax(0, 1fr) / 1fr;
        grid-template-areas:
            'header'
            'breadcrumbs'
            'main';
        height: 100%;
        width: 100%;
    }

    header {
        grid-area: header;
    }

    main {
        grid-area: main;
    }

    footer {
        grid-area: footer;
    }
</style>
